// Libs
import React from 'react';
import { Box, Typography } from '@mui/material';

// Components
import Rating from '../../../../../Rating';
import OutOfStockLabel from '../../../../Labels/OutOfStockLabel';
import CountComponent from '../../CountComponent';
import CloseComponent from '../../CloseComponent';
import OrderProductQtyLabels from '../../../../../Labels/OrderProductQtyLabels';
import ApprovalLabel from '../../../../../Labels/ApprovalLabel';
import ReportableIcon from '../../../../../Products/Card/ReportableIcon';

const LIST_BOX_PADDING = 2;

const DeviceView = ({
  product,
  order,
  orderItem,
  isRecurring,
  addressesCount,
  isMobileMode,
  isUnavailableForOrder,
  unavailableLabel,
  remainingMonthQuantity,
  classes,
  cx,
  onOpenModal,
  totalOrdered,
}) => {
  const {
    owner,
    rating: isRatable,
    reportable: isReportable,
    product_description: description,
    prepack_quantity,
    order_limit,
    product_available_qty,
    size_vers: sizeVers,
  } = product || {};

  const renderTitle = () =>
    isMobileMode ? (
      <Box position="relative" width="100%">
        {isRatable && <Rating product={product} />}
        <Typography
          onClick={onOpenModal}
          className={cx(
            classes.productDescription,
            classes.productMobileDescription,
            classes.clickable,
          )}
          // save empty space for close button when order is recurring
          width={isRecurring ? 'calc(100% - 30px)' : '100%'}
          data-testid="order-product-name">
          {description}
        </Typography>
        <Typography variant="textXs">{sizeVers}</Typography>
      </Box>
    ) : (
      <Box my={1}>
        <Typography
          onClick={onOpenModal}
          variant="h3"
          className={cx(classes.productDescription, classes.clickable)}
          data-testid="order-product-name">
          {description}
        </Typography>
        <Typography variant="textSm">{sizeVers}</Typography>
      </Box>
    );

  const renderTabletBody = () => (
    <>
      <Box display="flex" gap={2} mt={1}>
        <Box display="flex" flexDirection="column" flexBasis="50%">
          <Box display="flex" className={classes.inStockQty}>
            <Typography variant="textSmSemibold" color="darkGrey">
              Per Unit Qty: {prepack_quantity ? prepack_quantity : 'N/A'}
            </Typography>
          </Box>
          {order_limit !== null && (
            <Box display="flex">
              <Typography variant="textSmSemibold" color="darkGrey">
                Max Allowed Qty:&nbsp;
              </Typography>
              <Typography variant="textSmSemibold" color="darkGrey">
                {order_limit}
              </Typography>
            </Box>
          )}
          <div className={classes.qtyInfoText}>
            <OrderProductQtyLabels
              orderItem={orderItem}
              addressesCount={addressesCount}
              isRecurring={isRecurring}
            />
          </div>
          <Typography className={cx(classes.qtyInfoText, classes.totalItems)}>
            {`Total Items Ordered: ${prepack_quantity ? totalOrdered : 'N/A'}`}
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" flexBasis="40%">
          {isUnavailableForOrder ? (
            <OutOfStockLabel
              label={unavailableLabel}
              device={{ isMobileMode }}
            />
          ) : (
            <Typography variant="textSmSemibold" color="darkGrey">
              In Stock: {product_available_qty}
            </Typography>
          )}
          {remainingMonthQuantity !== null && remainingMonthQuantity >= 0 && (
            <Typography>{`${remainingMonthQuantity} left in month`}</Typography>
          )}
        </Box>
        <Box flexBasis="10%" display="flex" justifyContent="end">
          {isReportable && <ReportableIcon />}
        </Box>
      </Box>
      {isRecurring && !isUnavailableForOrder && (
        <Box display="flex" flex={1} gap={2}>
          <Box flexBasis="50%"></Box>
          <Box flexBasis="50%" className={classes.buttonContainer}>
            <CountComponent
              product={product}
              orderItem={orderItem}
              order={order}
            />
          </Box>
        </Box>
      )}
    </>
  );

  const renderMobileBody = () => (
    <Box
      className={classes.infoContainer}
      display="flex"
      flexDirection="column"
      flex={1}>
      {isUnavailableForOrder ? (
        <OutOfStockLabel label={unavailableLabel} device={{ isMobileMode }} />
      ) : (
        <Typography className={classes.qtyInfoText}>
          In Stock: {product_available_qty}
        </Typography>
      )}
      <Typography className={cx(classes.qtyInfoText, classes.totalItems)}>
        {`Total Items Ordered: ${prepack_quantity ? totalOrdered : 'N/A'}`}
      </Typography>
      {isRecurring && !isUnavailableForOrder && (
        <CountComponent product={product} orderItem={orderItem} order={order} />
      )}
    </Box>
  );

  return (
    <Box
      p={isMobileMode ? 1 : LIST_BOX_PADDING}
      width="100%"
      display="flex"
      flexDirection="column"
      position="relative">
      <Box position="relative">
        {isRecurring && (
          <CloseComponent
            className={classes.closeIcon}
            orderItem={orderItem}
            order={order}
            product={product}
          />
        )}
        {!isMobileMode && (
          <span className={classes.audienceLabel}>{owner}</span>
        )}
      </Box>
      {renderTitle()}
      {!isMobileMode && isRatable && <Rating product={product} />}
      {isMobileMode ? renderMobileBody() : renderTabletBody()}
      {!isRecurring && !isMobileMode && (
        <ApprovalLabel
          orderItemStatus={orderItem.status}
          approver={orderItem.approval?.approver}
          isModified={orderItem.qty_ordered !== orderItem.qty_approved}
          className={classes.approvalLabel}
        />
      )}
    </Box>
  );
};

export default DeviceView;
